type ContentByLanguage = Partial<Record<string, string | null | undefined>>

const FALLBACK_LANGUAGES_IN_PREFERENCE_ORDER = ["de", "en", "fr", "it"]

export const selectContentForLanguage = (language: string, contentByLanguage: ContentByLanguage): string => {
  const contentInRequestedLanguage = contentByLanguage[language]
  if (contentInRequestedLanguage) return contentInRequestedLanguage

  return (
    FALLBACK_LANGUAGES_IN_PREFERENCE_ORDER.map((fallbackLanguage) => contentByLanguage[fallbackLanguage]).find(
      (content) => !!content,
    ) ?? ""
  )
}
